import { cn } from "@utils";

export const DetailsTextarea = ({ field, error, submitted, touched, placeholder, compact = false, maxLength = 500 }) => {
  const showError = error && (touched || submitted);
  const len = field.value?.length ?? 0;
  return (
    <div className={cn("relative rounded-xl border overflow-hidden transition-all", "focus-within:ring-2 focus-within:ring-offset-0",
      showError ? "border-red-300 focus-within:ring-red-400" : "border-zinc-200 focus-within:ring-primary-500 focus-within:border-primary-500"
    )}>
      <textarea
        {...field}
        rows={compact ? 2 : 4}
        placeholder={placeholder}
        className="block w-full px-3 pt-2.5 pb-7 text-sm focus:outline-none resize-none bg-white text-zinc-900 placeholder:text-zinc-400"
      />
      <div className="absolute bottom-1.5 right-3 pointer-events-none">
        <span className={cn("text-xs tabular-nums", len > maxLength - 10 ? "text-red-500" : len > maxLength - 50 ? "text-amber-500" : "text-zinc-400")}>
          {len} / {maxLength}
        </span>
      </div>
    </div>
  );
};
